import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { setSubsite, getSubsite, reloadUser } from '../../reducers/auth';
import { clearCart, cart } from '../../reducers/cart';
import { getFeatured } from '../../reducers/catalog';
import { getMenu } from '../../reducers/menu';
import { useNavigate } from "react-router-dom";
import SubsiteService from "../../services/subsite.service";

const SwitchSiteModal = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentSite = useSelector(getSubsite);
  const cartItems = useSelector(cart);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedSite, setSelectedSite] = useState(currentSite?.abbreviation || null);
  const [showCartWarning, setShowCartWarning] = useState(false);
  const activeSubsites = (props.subsites || []).filter(
    (entry) => entry?.subsite && entry.subsite.active !== false
  );

  useEffect(() => {
    if (props.show) {
      setSelectedSite(currentSite?.abbreviation || null);
      setShowCartWarning(false);
      setIsSubmitting(false);
    }
  }, [props.show, currentSite?.abbreviation]);

  const findSelectedMembership = () => {
    if (selectedSite == null) return null;
    return activeSubsites.find(
      (entry) => entry.subsite.abbreviation === selectedSite
    ) || null;
  };

  const performSwitch = async (membership) => {
    if (!membership) return;
    setIsSubmitting(true);
    try {
      dispatch(setSubsite(membership));
      dispatch(clearCart());
      dispatch(getMenu(membership.subsite.id));
      await SubsiteService.setSubsite(membership.subsite);
      dispatch(getFeatured());
      dispatch(reloadUser());
      props.closeModal(false);
      if (typeof props.redirect === 'function') {
        props.redirect(membership.subsite);
      }
    } finally {
      setIsSubmitting(false);
      setShowCartWarning(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const membership = findSelectedMembership();
    if (!membership) return;

    // Same site — nothing to do
    if (membership.subsite.abbreviation === currentSite?.abbreviation) {
      props.closeModal(false);
      return;
    }

    if ((cartItems || []).length > 0) {
      setShowCartWarning(true);
      return;
    }

    await performSwitch(membership);
  };

  const handleContinueWithClear = async () => {
    const membership = findSelectedMembership();
    await performSwitch(membership);
  };

  const handleGoToCheckout = () => {
    setShowCartWarning(false);
    props.closeModal(false);
    navigate('/checkout');
  };

  const handleChange = (e) => {
    setSelectedSite(e.target.value);
    setShowCartWarning(false);
  };

  const modalClose = () => {
    setShowCartWarning(false);
    props.closeModal(false);
  };

  return (
    <Modal show={props.show} onHide={modalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Choose Site<br /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} >
          <Form.Group className="mb-3" controlId="state">
            <Form.Label>Sites you belong to:</Form.Label>
            <Form.Select
              name="site"
              value={selectedSite || ''}
              onChange={handleChange}
            >
              {activeSubsites.map((subsite) => (
                <option
                  key={"subsite_" + subsite.subsite.id}
                  value={subsite.subsite.abbreviation}
                >
                  {subsite.subsite.subsiteName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {showCartWarning && (
            <Alert variant="warning" className="mb-3">
              Your cart has items. Changing sites will clear your cart.
              Continue to switch sites, or go to checkout without changing sites.
            </Alert>
          )}

          <Modal.Footer>
            {showCartWarning ? (
              <>
                <Button variant="secondary" onClick={modalClose} disabled={isSubmitting}>
                  Cancel
                </Button>
                <Button variant="warning" onClick={handleGoToCheckout} disabled={isSubmitting}>
                  Go to Checkout
                </Button>
                <Button variant="danger" onClick={handleContinueWithClear} disabled={isSubmitting}>
                  Continue &amp; Clear Cart
                </Button>
              </>
            ) : (
              <>
                <Button variant="secondary" onClick={modalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Change Site
                </Button>
              </>
            )}
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SwitchSiteModal;
